(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('.product-tabs__trigger');
        if (!trigger) return;
        this.select(trigger);
      });
    }

    select(trigger) {
      this.querySelectorAll('.product-tabs__trigger').forEach((el) => {
        el.setAttribute('aria-selected', el === trigger ? 'true' : 'false');
      });
      this.querySelectorAll('.product-tabs__panel').forEach((panel) => {
        panel.hidden = panel.id !== trigger.getAttribute('aria-controls');
      });
    }
  }

  customElements.define('product-tabs', ProductTabs);

  } catch(e) { console.error(e); }
})();
})();
